import { observable } from 'mobx';
import useMount from '@src/utils/hooks/use-mount';
import { noop } from '@src/utils/common-util';
import { autobind } from 'core-decorators';
import { useUnmount } from 'ahooks';

class VideoModalStore {
  onClose = noop;
  /**
   * 是否展开
   * @type {boolean}
   */
  @observable isOpen = false;

  /**
   * 视频id
   * @type {string}
   */
  @observable src = '';

  /**
   * 点击关闭按钮时回调
   */
  @autobind
  onCloseBtnClick() {
    this.isOpen = false;
    this.onClose();
  }

  use() {
    useMount(() => {
      this.isOpen = true;
    });
    useUnmount(() => {
      this.src = '';
    });
  }
}

export default VideoModalStore;
